const useIsInDiscord = () => {
  const url = new URL(location.href);
  return url.hostname.includes('discordsays.com');
};

export default useIsInDiscord;
